import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=02050681&"
import script from "./Staff.js?vue&type=script&lang=js&"
export * from "./Staff.js?vue&type=script&lang=js&"
import style0 from "./Staff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports